import React from 'react';
import PageLayout from "../../components/PageLayout/PageLayout";
import '../bookpage.css'
import Title from '../../components/Title/Title';

export default function RemoveStumblingBlocks() {
  return (
    <PageLayout>
      <div className="book-page">
      <Title title="Remove Anything From Your Surroundings That Makes you Stumble" />
        <blockquote>
  “But put on the Lord Jesus Christ, and make no provision for the flesh in regard to its lusts.” (Romans 13:14)
</blockquote>

<p>
  We need to remove ourselves from the presence of things or individuals who make us stumble. We need to get away from the things that tempt us. It is extremely difficult to keep one’s mind set on the things above when our flesh is being continually enticed by sinful habits, including things that may be out of sight but still accessible to us. This is particularly true for substances that our bodies crave and become addicted to, such as drugs, tobacco, alcohol, pornography, and immoral behavior. We must remove any and all things in our lives that have even the remotest possibility of taking us back to sin. Throw out or destroy any and all pornography in every form – movies, books, magazines – and remove any chance of going to pornographic internet sites by using a filtering program, a must for men. Stop going to or watching movies that depict immorality, and cancel your cable television if it is a source of temptation. Remove from your home any occult objects or things that bother your conscience. Don’t worry about what it may have cost, no amount of money is worth your stumbling in sin. Don’t go to parties or peoples’ homes if there are things there that will be a struggle for you. If there are people who are tempting you to sinful behaviors, share the gospel with them and stop associating with them. “Do not be deceived, bad company corrupts good morals.” (1 Corinthians 15:33) Find other godly Christians to associate with, to build you up. Eve sinned because she was found near enough to the tree to gaze at its fruit. Don’t go near the tree, and don’t keep some of its fruit in your possession.
</p>

<ul>
  <li>
    <strong>Stay away from the tree!</strong> Do not gaze at its fruit. Don’t go near temptation’s door.<br />
    <em>Genesis 3:6, Proverbs 5:8, 7:7-9, 25, 23:29-35</em>
  </li>
  <li>
    Remove from your possession alcohol, drugs, food, magazines, or anything that makes you stumble.<br />
    <em>Isaiah 30:22, Matthew 5:29-30, Acts 19:19</em>
  </li>
  <li>
    Set up barriers to sin; make it difficult if not impossible to proceed in the way of sin. Limit and control access to the internet and other potentially harmful things. Make no provision for the flesh.<br />
    <em>Psalm 141:3-4, Jeremiah 4:1, Romans 13:14</em>
  </li>
  <li>
    Turn off the movie and TV!!!!!!! Refuse to set any worthless thing before your eyes.<br />
    <em>Psalm 101:3-4</em>
  </li>
  <li>
    Do not listen to the counsel of the unrighteous, and do not participate in their deeds.<br />
    <em>Psalm 1, Proverbs 5:3-6, 7:10-23, 1 Corinthians 15:33, Ephesians 5:6-17, 1 Peter 2:11-12, 4:3-4</em>
  </li>
  <li>
    Take note of times and circumstances that bring temptation and avoid them.<br />
    <em>Proverbs 27:12</em>
  </li>
  <li>
    Restrain your feet from every evil way. Abhor what is evil.<br />
    <em>Psalm 18:23, 119:101, Proverbs 4:14-15, 23-27, Romans 12:9</em>
  </li>
</ul>

      </div>
    </PageLayout>
  );
};
